/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRentDto } from '../../models/backend-rent-dto';
import { BackendRentRequestDto } from '../../models/backend-rent-request-dto';

export interface OpexesRentUpdate$Params {
  id: number;
  body: BackendRentRequestDto;
}

export function opexesRentUpdate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesRentUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRentDto>> {
  const rb = new RequestBuilder(rootUrl, opexesRentUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRentDto>;
    }),
  );
}

opexesRentUpdate.PATH = '/api/opexes/rent/{id}/';
